// 教研工具数据：整理自 https://edui123.com/ 公开导航，共 588 个工具 / 25 个分类
export default [
  {
    "cate": "课前准备",
    "tools": [
      {
        "n": "Get笔记",
        "d": "日常记笔记，找笔记，转存零碎信息",
        "u": "https://www.biji.com/"
      },
      {
        "n": "AI教育实验室",
        "d": "Get笔记知识库",
        "u": "https://biji.com/topic/oYpDwV6Y"
      },
      {
        "n": "ima 腾讯智能工作台",
        "d": "个人专属知识库",
        "u": "https://ima.qq.com/"
      },
      {
        "n": "希沃AI备课",
        "d": "当前最靠谱的备课，支持对话智能体",
        "u": "https://bloom.seewo.com/"
      },
      {
        "n": "人教1上数学备课助手",
        "d": "基于教师用书的豆包智能体",
        "u": "https://doubao.com/bot/nswmhmYP"
      },
      {
        "n": "国家智慧教育平台",
        "d": "拥有全年龄全年段全学科教学资源",
        "u": "https://www.smartedu.cn/"
      },
      {
        "n": "教育学学科大模型",
        "d": "华东师范大学，超过130 GB的私有教育教学语料",
        "u": "https://innospark.aiecnu.cn/"
      },
      {
        "n": "人工智能学科大模型",
        "d": "浙江大学，提供学习计划定制、习题生成、错题解析、教学大纲生成等",
        "u": "https://sanle.hep.com.cn/"
      }
    ]
  },
  {
    "cate": "课中互动",
    "tools": [
      {
        "n": "乘法消消乐",
        "d": "",
        "u": "https://edui123.com/cfxxl/"
      },
      {
        "n": "数字华容道",
        "d": "",
        "u": "https://edui123.com/szhrd/"
      },
      {
        "n": "方向华容道",
        "d": "",
        "u": "https://edui123.com/hrd/"
      },
      {
        "n": "全班排队游戏",
        "d": "",
        "u": "https://edui123.com/zhishu/"
      },
      {
        "n": "数对五子棋",
        "d": "",
        "u": "https://edui123.com/wzq/"
      },
      {
        "n": "拆弹专家",
        "d": "",
        "u": "https://edui123.com/chaidan/"
      },
      {
        "n": "“四连方”拼图游戏（教学版）",
        "d": "",
        "u": "https://edui123.com/slfpt/"
      },
      {
        "n": "“四连方”拼图游戏（自由拼组）",
        "d": "",
        "u": "https://edui123.com/slftz/"
      },
      {
        "n": "数字碰碰乐",
        "d": "",
        "u": "https://edui123.com/fjzys/"
      },
      {
        "n": "决战24点",
        "d": "",
        "u": "https://edui123.com/24/"
      },
      {
        "n": "数学游戏：路线规划大挑战",
        "d": "",
        "u": "https://edui123.com/lxgh/"
      },
      {
        "n": "数字顺序大对战",
        "d": "",
        "u": "https://edui123.com/szsxddz/"
      },
      {
        "n": "手绘点格棋",
        "d": "",
        "u": "https://edui123.com/dgq/"
      },
      {
        "n": "幼小衔接游戏“牛角棋”",
        "d": "",
        "u": "https://edui123.com/njq/"
      },
      {
        "n": "纸带算数",
        "d": "",
        "u": "https://edui123.com/zdss/"
      },
      {
        "n": "数学游戏：凑十泡泡龙",
        "d": "",
        "u": "https://edui123.com/csppl/"
      },
      {
        "n": "自制几何画板",
        "d": "",
        "u": "https://txyjh.com/"
      },
      {
        "n": "正方体画板",
        "d": "",
        "u": "https://edui123.com/zfthb/"
      },
      {
        "n": "两点间的距离",
        "d": "",
        "u": "https://edui123.com/ldjl/"
      },
      {
        "n": "喝果汁问题",
        "d": "",
        "u": "https://edui123.com/hgz/"
      },
      {
        "n": "喝果汁问题",
        "d": "",
        "u": "https://edui123.com/hgzpro/"
      },
      {
        "n": "面积一定，谁的周长最短",
        "d": "",
        "u": "https://edui123.com/mjyd/"
      },
      {
        "n": "周长一定，谁的面积最大",
        "d": "",
        "u": "https://edui123.com/zcyd/"
      },
      {
        "n": "扫地机器人（圆绕长方形）",
        "d": "",
        "u": "https://edui123.com/sdjqr/"
      },
      {
        "n": "圆绕方、绕圆、绕三角形",
        "d": "",
        "u": "https://edui123.com/yuanrao/"
      },
      {
        "n": "小圆绕大圆，到底转几圈",
        "d": "",
        "u": "https://edui123.com/xydy/"
      },
      {
        "n": "圆们的周长和面积",
        "d": "",
        "u": "https://edui123.com/yuanzy/"
      },
      {
        "n": "有趣的平衡",
        "d": "",
        "u": "https://edui123.com/yqdph/"
      },
      {
        "n": "自行车里的数学",
        "d": "",
        "u": "https://edui123.com/zxc/"
      },
      {
        "n": "阴影部分的周长",
        "d": "",
        "u": "https://edui123.com/yybfzc1/"
      },
      {
        "n": "三角形旋转扫过的区域面积",
        "d": "",
        "u": "https://edui123.com/sjxsg/"
      },
      {
        "n": "长方体盒子剪开",
        "d": "",
        "u": "https://edui123.com/cfthz/"
      },
      {
        "n": "剪长方体盒子",
        "d": "",
        "u": "https://edui123.com/jzh/"
      },
      {
        "n": "长方体圆柱组合旋转",
        "d": "",
        "u": "https://edui123.com/xt3ap5/"
      },
      {
        "n": "数与形",
        "d": "",
        "u": "https://edui123.com/syx/"
      },
      {
        "n": "确定起跑线",
        "d": "",
        "u": "https://edui123.com/qpx/"
      },
      {
        "n": "校园3D小导游",
        "d": "",
        "u": "https://edui123.com/xiaoyuan/"
      },
      {
        "n": "相对位置路线图",
        "d": "",
        "u": "https://edui123.com/xdwz/"
      },
      {
        "n": "三维虚拟地球仪",
        "d": "",
        "u": "https://edui123.com/jwd/"
      },
      {
        "n": "用方向和距离确定位置",
        "d": "",
        "u": "https://edui123.com/qdwz/"
      },
      {
        "n": "虚拟天平秤",
        "d": "",
        "u": "https://edui123.com/tp/"
      },
      {
        "n": "虚拟天平秤“找次品”",
        "d": "",
        "u": "https://edui123.com/zcp/"
      },
      {
        "n": "怎样通知最快",
        "d": "",
        "u": "https://edui123.com/zytz/"
      },
      {
        "n": "神秘的机器人",
        "d": "",
        "u": "https://edui123.com/jqr/"
      },
      {
        "n": "解码“身份证”",
        "d": "",
        "u": "https://edui123.com/szbm/"
      },
      {
        "n": "数学广角——重叠问题",
        "d": "",
        "u": "https://edui123.com/cdwt/"
      },
      {
        "n": "“田忌赛马”策略实验室",
        "d": "",
        "u": "https://edui123.com/tjsm/"
      },
      {
        "n": "校园寻宝",
        "d": "",
        "u": "https://edui123.com/xyxb/"
      },
      {
        "n": "圆的认识",
        "d": "",
        "u": "https://edui123.com/yztc/"
      },
      {
        "n": "圆出于方",
        "d": "",
        "u": "https://edui123.com/hfwy/"
      },
      {
        "n": "方与圆",
        "d": "",
        "u": "https://edui123.com/fangyuan/"
      },
      {
        "n": "方内圆空白面积",
        "d": "",
        "u": "https://edui123.com/fnymj/"
      },
      {
        "n": "轮子为什么是圆的",
        "d": "",
        "u": "https://edui123.com/lunzi/"
      },
      {
        "n": "如果轮子不是圆的",
        "d": "",
        "u": "https://edui123.com/chelun/"
      },
      {
        "n": "圆内直径最长",
        "d": "",
        "u": "https://edui123.com/zhijing/"
      },
      {
        "n": "圆的周长测量（滚动法）",
        "d": "",
        "u": "https://edui123.com/ygdf/"
      },
      {
        "n": "捆多个圆需要多长绳子",
        "d": "",
        "u": "https://edui123.com/xtky/"
      },
      {
        "n": "两个半圆叠拼，涂色面积是多少",
        "d": "",
        "u": "https://edui123.com/bydp/"
      },
      {
        "n": "栓绳小狗活动面积",
        "d": "",
        "u": "https://edui123.com/xiaogou/"
      },
      {
        "n": "圆的面积",
        "d": "",
        "u": "https://edui123.com/ymj/"
      },
      {
        "n": "方格中估计“圆的面积”",
        "d": "",
        "u": "https://edui123.com/fgyuan/"
      },
      {
        "n": "利用圆设计图案",
        "d": "",
        "u": "https://edui123.com/yigeyuan/"
      },
      {
        "n": "割圆术",
        "d": "",
        "u": "https://edui123.com/geyuan/"
      },
      {
        "n": "有趣的投影",
        "d": "",
        "u": "https://edui123.com/yqdty/"
      },
      {
        "n": "一张想怎么折就能怎么折的纸",
        "d": "",
        "u": "https://edui123.com/zhezhi/"
      },
      {
        "n": "两条直线的位置关系",
        "d": "",
        "u": "https://edui123.com/ltzx/"
      },
      {
        "n": "不相交的两条直线，能叫“平行线”吗？",
        "d": "",
        "u": "https://edui123.com/pxx/"
      },
      {
        "n": "垂直线段最短",
        "d": "",
        "u": "https://edui123.com/czxd/"
      },
      {
        "n": "翻滚正方体",
        "d": "",
        "u": "https://edui123.com/fgzft/"
      },
      {
        "n": "绳子对折，对折再对折",
        "d": "",
        "u": "https://edui123.com/szdz/"
      },
      {
        "n": "探索三角形三边关系",
        "d": "",
        "u": "https://edui123.com/sbgx/"
      },
      {
        "n": "7个正方体组合体如何旋转",
        "d": "",
        "u": "https://edui123.com/xt5ap6/"
      },
      {
        "n": "画轴对称图形另一半",
        "d": "",
        "u": "https://edui123.com/xt5ap54/"
      },
      {
        "n": "有趣的密铺",
        "d": "",
        "u": "https://edui123.com/mipu/"
      },
      {
        "n": "曹冲称象",
        "d": "",
        "u": "https://edui123.com/cccx/"
      },
      {
        "n": "铁环连在一起到底有多长",
        "d": "",
        "u": "https://edui123.com/xt3ap24/"
      },
      {
        "n": "分橘子",
        "d": "",
        "u": "https://edui123.com/pjf/"
      },
      {
        "n": "公顷和平方千米",
        "d": "",
        "u": "https://edui123.com/gongqing/"
      },
      {
        "n": "剪长方形",
        "d": "",
        "u": "https://edui123.com/jcfx/"
      },
      {
        "n": "四分之一的秘密",
        "d": "",
        "u": "https://edui123.com/sfzy/"
      },
      {
        "n": "一张可自由对折的纸",
        "d": "",
        "u": "https://edui123.com/cfxz/"
      },
      {
        "n": "分数墙",
        "d": "",
        "u": "https://edui123.com/fenshu/"
      },
      {
        "n": "一副三角尺",
        "d": "",
        "u": "https://edui123.com/sjc/"
      },
      {
        "n": "多边形面积",
        "d": "",
        "u": "https://edui123.com/dbx/"
      },
      {
        "n": "多边形面积（自由绘制）",
        "d": "",
        "u": "https://edui123.com/dbxmj/"
      },
      {
        "n": "平行四边形的面积",
        "d": "",
        "u": "https://edui123.com/pxsbxmj/"
      },
      {
        "n": "不规则图形面积",
        "d": "",
        "u": "https://edui123.com/znmj/"
      },
      {
        "n": "正方形与三角形相遇问题",
        "d": "",
        "u": "https://edui123.com/zfsjyd/"
      },
      {
        "n": "草坪里的两条小路",
        "d": "",
        "u": "https://edui123.com/ltxl/"
      },
      {
        "n": "小路面积",
        "d": "",
        "u": "https://edui123.com/xlmj/"
      },
      {
        "n": "小路草地面积是多少",
        "d": "",
        "u": "https://edui123.com/xlcdmj/"
      },
      {
        "n": "长方体的认识",
        "d": "",
        "u": "https://edui123.com/cft/"
      },
      {
        "n": "长方体的认识（三维立体版）",
        "d": "",
        "u": "https://edui123.com/rscft/"
      },
      {
        "n": "平行四边形的认识",
        "d": "",
        "u": "https://edui123.com/pxsbx/"
      },
      {
        "n": "大长方形的周长和面积各是多少",
        "d": "",
        "u": "https://edui123.com/xt4a40-sj/"
      },
      {
        "n": "第四点，在哪儿",
        "d": "",
        "u": "https://edui123.com/dsd/"
      },
      {
        "n": "摸数比大小",
        "d": "",
        "u": "https://edui123.com/moshu/"
      },
      {
        "n": "倒水问题",
        "d": "",
        "u": "https://edui123.com/shuitong/"
      },
      {
        "n": "长方体的体积",
        "d": "",
        "u": "https://edui123.com/cfttj/"
      },
      {
        "n": "相邻体积单位的进率",
        "d": "",
        "u": "https://edui123.com/tjdw/"
      },
      {
        "n": "无盖盒子容积",
        "d": "",
        "u": "https://edui123.com/hzrj/"
      },
      {
        "n": "圆柱的体积公式推导",
        "d": "",
        "u": "https://edui123.com/ytj/"
      },
      {
        "n": "圆柱的展开图",
        "d": "",
        "u": "https://edui123.com/yzcm/"
      },
      {
        "n": "砍木桩，一刀切两段",
        "d": "",
        "u": "https://edui123.com/kmz/"
      },
      {
        "n": "平面图形旋转成体",
        "d": "",
        "u": "https://edui123.com/xzct/"
      },
      {
        "n": "卷个圆柱（长方体）",
        "d": "",
        "u": "https://edui123.com/jzcz/"
      },
      {
        "n": "圆锥与圆柱的体积变化",
        "d": "",
        "u": "https://edui123.com/yzyzbh/"
      },
      {
        "n": "分与合",
        "d": "",
        "u": "https://edui123.com/fyh/"
      },
      {
        "n": "十格阵",
        "d": "",
        "u": "https://edui123.com/shige/"
      },
      {
        "n": "九宫格填数",
        "d": "",
        "u": "https://edui123.com/jgg/"
      },
      {
        "n": "有余数除法",
        "d": "",
        "u": "https://edui123.com/yyscf/"
      },
      {
        "n": "有余数除法各部分关系",
        "d": "",
        "u": "https://edui123.com/yysgx/"
      },
      {
        "n": "探索因数的个数",
        "d": "",
        "u": "https://edui123.com/yinshu/"
      },
      {
        "n": "年月历",
        "d": "",
        "u": "https://edui123.com/nyr/"
      },
      {
        "n": "鸡兔同笼",
        "d": "",
        "u": "https://edui123.com/jttl/"
      },
      {
        "n": "3年有多长",
        "d": "",
        "u": "https://edui123.com/dashu/"
      },
      {
        "n": "可拖拽日历",
        "d": "",
        "u": "https://edui123.com/30/"
      },
      {
        "n": "数数",
        "d": "",
        "u": "https://edui123.com/shushu/"
      },
      {
        "n": "玩转百数表",
        "d": "",
        "u": "https://edui123.com/wzbsb/"
      },
      {
        "n": "几个几",
        "d": "",
        "u": "https://edui123.com/jgj/"
      },
      {
        "n": "千以内数的认识",
        "d": "",
        "u": "https://edui123.com/ysbq/"
      },
      {
        "n": "万以内数的认识",
        "d": "",
        "u": "https://edui123.com/szft/"
      },
      {
        "n": "虚拟“中国算盘”",
        "d": "",
        "u": "https://edui123.com/suanpan/"
      },
      {
        "n": "乘积最值问题",
        "d": "",
        "u": "https://edui123.com/cjwt/"
      },
      {
        "n": "两位数乘积最值问题（面积模型）",
        "d": "",
        "u": "https://edui123.com/cjzz/"
      },
      {
        "n": "乘积最值问题（三位数乘一位数）",
        "d": "",
        "u": "https://edui123.com/xt3ap54/"
      },
      {
        "n": "数字黑洞",
        "d": "",
        "u": "https://edui123.com/szhd/"
      },
      {
        "n": "麦粒棋盘问题",
        "d": "",
        "u": "https://edui123.com/mlqp/"
      },
      {
        "n": "神奇的刻度尺",
        "d": "",
        "u": "https://edui123.com/michi/"
      },
      {
        "n": "小数方格",
        "d": "",
        "u": "https://edui123.com/xsfg/"
      },
      {
        "n": "循环小数计算器",
        "d": "",
        "u": "https://edui123.com/xhxs/"
      },
      {
        "n": "数的转换",
        "d": "",
        "u": "https://edui123.com/shugai/"
      },
      {
        "n": "小数与分数乘法的意义",
        "d": "",
        "u": "https://edui123.com/xsfscf/"
      },
      {
        "n": "“分数乘分数”算理可视化",
        "d": "",
        "u": "https://edui123.com/fsxfs/"
      },
      {
        "n": "点 c 会在哪个位置呢",
        "d": "",
        "u": "https://edui123.com/axb/"
      },
      {
        "n": "小萍家地板离地面有多高",
        "d": "",
        "u": "https://edui123.com/xt6ap38/"
      },
      {
        "n": "小明和爷爷一起去操场散步",
        "d": "",
        "u": "https://edui123.com/xt6ap40/"
      },
      {
        "n": "“工程问题”线段图对比",
        "d": "",
        "u": "https://edui123.com/gcwt/"
      },
      {
        "n": "数一数，小正方体有几个",
        "d": "",
        "u": "https://edui123.com/sys/"
      },
      {
        "n": "组合正方体",
        "d": "",
        "u": "https://edui123.com/3d/"
      },
      {
        "n": "还原组合正方体",
        "d": "",
        "u": "https://edui123.com/hyzft/"
      },
      {
        "n": "摆正方体",
        "d": "",
        "u": "https://edui123.com/bzft/"
      },
      {
        "n": "围正方体",
        "d": "",
        "u": "https://edui123.com/wzft/"
      },
      {
        "n": "组合体的表面积",
        "d": "",
        "u": "https://edui123.com/zhtbmj/"
      },
      {
        "n": "如何拼组长方体，表面积最小",
        "d": "",
        "u": "https://edui123.com/pzcft/"
      },
      {
        "n": "简单格子",
        "d": "",
        "u": "https://edui123.com/gezi/"
      },
      {
        "n": "铺地毯",
        "d": "",
        "u": "https://edui123.com/xt3bpdt/"
      },
      {
        "n": "台阶的地毯（三维版）",
        "d": "",
        "u": "https://edui123.com/tjdt/"
      },
      {
        "n": "花坛面积是多少",
        "d": "",
        "u": "https://edui123.com/htmj/"
      },
      {
        "n": "虚拟折剪纸",
        "d": "",
        "u": "https://edui123.com/xnzjz/"
      },
      {
        "n": "烙饼问题",
        "d": "",
        "u": "https://edui123.com/lbwt/"
      },
      {
        "n": "口算卡片",
        "d": "",
        "u": "https://edui123.com/ks/"
      },
      {
        "n": "简单时钟",
        "d": "",
        "u": "https://edui123.com/zhongmian/"
      },
      {
        "n": "简单时钟",
        "d": "",
        "u": "https://edui123.com/clock/"
      },
      {
        "n": "可打印时钟",
        "d": "",
        "u": "https://edui123.com/dyzm/"
      },
      {
        "n": "百变百数表",
        "d": "",
        "u": "https://edui123.com/bai/"
      },
      {
        "n": "3的倍数特征",
        "d": "",
        "u": "https://edui123.com/bs3/"
      },
      {
        "n": "筛数表",
        "d": "",
        "u": "https://edui123.com/shu/"
      },
      {
        "n": "极简百数表",
        "d": "",
        "u": "https://edui123.com/bsb/"
      },
      {
        "n": "圈圈小圆点",
        "d": "",
        "u": "https://edui123.com/quan/"
      },
      {
        "n": "轴对称演示",
        "d": "",
        "u": "https://edui123.com/zdc/"
      },
      {
        "n": "下面哪些图形是轴对称图形",
        "d": "",
        "u": "https://edui123.com/zdctx/"
      },
      {
        "n": "折线统计图",
        "d": "",
        "u": "https://edui123.com/tjzx/"
      },
      {
        "n": "条形变扇形统计图",
        "d": "",
        "u": "https://edui123.com/bsx/"
      },
      {
        "n": "虚拟实验室“掷一掷”",
        "d": "",
        "u": "https://edui123.com/zyz/"
      },
      {
        "n": "可能性",
        "d": "",
        "u": "https://edui123.com/knx/"
      },
      {
        "n": "垃圾总量自动推算笔记本",
        "d": "",
        "u": "https://edui123.com/ljts/"
      },
      {
        "n": "角度估算器",
        "d": "",
        "u": "https://edui123.com/jiao/"
      },
      {
        "n": "破碎量角器生成器",
        "d": "",
        "u": "https://edui123.com/psljq/"
      },
      {
        "n": "∠1 与∠2 为什么都相等",
        "d": "",
        "u": "https://edui123.com/xt4ap38/"
      },
      {
        "n": "体验“圆周角定理”",
        "d": "",
        "u": "https://edui123.com/xt4ap38-6/"
      },
      {
        "n": "三角形三边关系",
        "d": "",
        "u": "https://edui123.com/bian/"
      },
      {
        "n": "一张三角形纸折叠，∠3和∠4是几度呢",
        "d": "",
        "u": "https://edui123.com/kt4a-19-4/"
      },
      {
        "n": "围长方形",
        "d": "",
        "u": "https://edui123.com/zc/"
      },
      {
        "n": "定长线段围面",
        "d": "",
        "u": "https://edui123.com/xdwm/"
      },
      {
        "n": "平移计算图形的面积",
        "d": "",
        "u": "https://edui123.com/pymj/"
      },
      {
        "n": "平移计算周长的周长",
        "d": "",
        "u": "https://edui123.com/pyzc/"
      },
      {
        "n": "一张纸连续对折3次",
        "d": "",
        "u": "https://edui123.com/lxdz/"
      },
      {
        "n": "最短路径",
        "d": "",
        "u": "https://edui123.com/lu/"
      },
      {
        "n": "质数流水线",
        "d": "",
        "u": "https://edui123.com/zs/"
      },
      {
        "n": "通分",
        "d": "",
        "u": "https://edui123.com/tongfen/"
      },
      {
        "n": "候课小工具“短除法”",
        "d": "",
        "u": "https://edui123.com/hkdcf/"
      },
      {
        "n": "“铺地砖”问题",
        "d": "",
        "u": "https://edui123.com/pdzwt/"
      },
      {
        "n": "“最大公因数”智能分析器",
        "d": "",
        "u": "https://edui123.com/zdgys/"
      },
      {
        "n": "为什么小正方体的最大棱长是4",
        "d": "",
        "u": "https://edui123.com/kzzdgys/"
      },
      {
        "n": "约分",
        "d": "",
        "u": "https://edui123.com/yuefen/"
      },
      {
        "n": "判断乘积奇偶性",
        "d": "",
        "u": "https://edui123.com/ji/"
      },
      {
        "n": "生日条形统计图",
        "d": "",
        "u": "https://edui123.com/tjsr/"
      },
      {
        "n": "认识平均数之小马过河",
        "d": "",
        "u": "https://edui123.com/xmgh/"
      },
      {
        "n": "全班投票小工具",
        "d": "",
        "u": "https://edui123.com/toupiao/"
      },
      {
        "n": "虚拟钉子板",
        "d": "",
        "u": "https://edui123.com/dzb/"
      },
      {
        "n": "虚拟温度计",
        "d": "",
        "u": "https://edui123.com/wdj/"
      },
      {
        "n": "水的沸腾",
        "d": "",
        "u": "https://edui123.com/feiteng/"
      },
      {
        "n": "月相变化的规律",
        "d": "",
        "u": "https://edui123.com/yxbh/"
      },
      {
        "n": "组装台灯",
        "d": "",
        "u": "https://edui123.com/zztd/"
      },
      {
        "n": "双影积木",
        "d": "在线设计双影积木艺术作品",
        "u": "https://sombras.app/"
      },
      {
        "n": "乘法分配律",
        "d": "通过切割长方形的边来学习“乘法分配律”",
        "u": "https://apps.mathlearningcenter.org/partial-product-finder/"
      }
    ]
  },
  {
    "cate": "课后深思",
    "tools": [
      {
        "n": "通义千问",
        "d": "快速音视频逐字稿、提取课件等",
        "u": "https://tongyi.aliyun.com/"
      },
      {
        "n": "飞书妙记",
        "d": "音视频转文字，逐字稿同步查看",
        "u": "https://www.feishu.cn/product/minutes"
      },
      {
        "n": "飞书多维表格",
        "d": "批量 DeepSeek 自动化表格",
        "u": "https://i0l33avgq1.feishu.cn/base/WhB4bh0pIadKR3sTkT1cJh5lntg"
      },
      {
        "n": "秘塔 AI 搜索",
        "d": "学术研究利器",
        "u": "https://metaso.cn/"
      }
    ]
  },
  {
    "cate": "案例优选",
    "tools": [
      {
        "n": "AI对话一键转Word",
        "d": "",
        "u": "https://edui123.com/word/"
      },
      {
        "n": "自制“在线网页编辑器”",
        "d": "",
        "u": "https://html.edui123.com/"
      },
      {
        "n": "创意文字提示词生成",
        "d": "",
        "u": "https://edui123.com/jm/"
      },
      {
        "n": "云朵字生成器",
        "d": "",
        "u": "https://edui123.com/ydz/"
      },
      {
        "n": "作业登记表情包",
        "d": "",
        "u": "https://edui123.com/zy/"
      },
      {
        "n": "幸运大转盘",
        "d": "",
        "u": "https://edui123.com/dzp/"
      },
      {
        "n": "体育教学场地组织示意图",
        "d": "【v166】体育教学场地组织示意图绘制系统1234",
        "u": "https://go32279q.html2web.com/"
      },
      {
        "n": "数学单元教学梳理",
        "d": "小学数学单元教学梳理及互动工具",
        "u": "https://t6n7wbfcuv.feishu.cn/wiki/U4XywJkZLib860kN4yzckf7lnYd"
      },
      {
        "n": "五木严选",
        "d": "个人公众号十分推荐",
        "u": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzI2MTM3NTU1NA==\\u0026action=getalbum\\u0026album_id=4136219878418022408#wechat_redirect"
      },
      {
        "n": "创意字体设计",
        "d": "内置近百款优质文字提示词，可一键生成创意文字设计",
        "u": "https://www.coze.cn/s/3LXtmi5l8Nw/"
      },
      {
        "n": "创意海报设计",
        "d": "系统分析匹配多元风格，可一键生成创意海报设计",
        "u": "https://www.coze.cn/s/OIy70exSj1c/"
      },
      {
        "n": "立体纸雕绘本",
        "d": "快速生成立体纸雕绘本图片",
        "u": "https://www.coze.cn/s/p8FhD-yZey4/"
      },
      {
        "n": "公式图片生成",
        "d": "想要什么公式，直说就行，一键下载透明公式图片",
        "u": "https://doubao.com/bot/3YFsU45X"
      },
      {
        "n": "教师AI应用手册2.0",
        "d": "深圳市福田区 AI 先锋队",
        "u": "https://docs.qq.com/doc/DSG9SWFpjVXl3aHZ1"
      },
      {
        "n": "乐清小学数学",
        "d": "微信公众号，学历案专辑",
        "u": "https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzA3NDM2MzgzOQ==\\u0026action=getalbum\\u0026album_id=2437227017952935937"
      }
    ]
  },
  
  {
    "cate": "备用留存",
    "tools": [
      {
        "n": "智谱清言",
        "d": "",
        "u": "https://chatglm.cn/main/detail"
      },
      {
        "n": "Kimi",
        "d": "",
        "u": "https://kimi.moonshot.cn/"
      },
      {
        "n": "文心一言",
        "d": "",
        "u": "https://yiyan.baidu.com/"
      },
      {
        "n": "混元",
        "d": "",
        "u": "https://hunyuan.tencent.com/bot"
      },
      {
        "n": "星火",
        "d": "",
        "u": "https://xinghuo.xfyun.cn/"
      },
      {
        "n": "百川",
        "d": "",
        "u": "https://www.baichuan-ai.com/"
      },
      {
        "n": "商量",
        "d": "",
        "u": "https://chat.sensetime.com/"
      },
      {
        "n": "跃问",
        "d": "",
        "u": "https://stepchat.cn/"
      },
      {
        "n": "万知",
        "d": "",
        "u": "https://wanzhi.com/"
      },
      {
        "n": "Dify",
        "d": "",
        "u": "https://dify.ai/"
      },
      {
        "n": "天工 AI",
        "d": "",
        "u": "https://search.tiangong.cn/"
      }
    ]
  },
  {
    "cate": "语言文学",
    "tools": [
      {
        "n": "中小学语文示范诵读库",
        "d": "课文朗读",
        "u": "https://szyb.smartedu.cn/library/18cd1ab4-5560-472f-953a-85de88736aa2/catalog?defaultTag=81e17dbb-837d-43bf-9baa-7fac2c16725e"
      },
      {
        "n": "认读小能手",
        "d": "语文一上识字表 280 字过关",
        "u": "https://edui123.com/renzi/"
      },
      {
        "n": "词语听写",
        "d": "自动朗读语文书后“词语表”",
        "u": "https://edui123.com/tingxie/"
      },
      {
        "n": "胡三元书法视频",
        "d": "一上“写字表”书法视频课件",
        "u": "https://13.r302.cc/24epjWZ"
      },
      {
        "n": "淡墨水字帖",
        "d": "语数英字帖在线生成下载",
        "u": "https://danmoshui.com/"
      },
      {
        "n": "字帖生成工具",
        "d": "每个人都能写出一手漂亮的字",
        "u": "https://paper.z2h.cn/"
      },
      {
        "n": "字帖生成器",
        "d": "在线生成并打印描字帖、笔顺描写贴和常用字体模板",
        "u": "https://tool.lu/copybook/index.html"
      },
      {
        "n": "纸由我",
        "d": "自定义打印纸生成器",
        "u": "https://paperme.toolooz.com/"
      },
      {
        "n": "儿童文学阅读",
        "d": "小学生课外阅读书大全",
        "u": "https://www.ppzuowen.com/book/"
      },
      {
        "n": "学笔画",
        "d": "笔顺动画和练习",
        "u": "https://edui123.com/xuebihua/"
      },
      {
        "n": "猜四字词语",
        "d": "在线猜字，汉兜 Wordle",
        "u": "https://handle.antfu.me/"
      },
      {
        "n": "猜成语",
        "d": "在线猜成语",
        "u": "https://edui123.com/chengyu/"
      },
      {
        "n": "古诗连词",
        "d": "古诗连连看",
        "u": "https://poetrystrands.com/zh"
      },
      {
        "n": "字统网",
        "d": "汉字源在线查询",
        "u": "https://zi.tools/"
      },
      {
        "n": "汉典",
        "d": "免费在线辞典",
        "u": "https://www.zdic.net/"
      },
      {
        "n": "成语接龙机器人",
        "d": "一次性生成一组成语接龙组合",
        "u": "https://www.xiaohui.com/chengyu/"
      },
      {
        "n": "深言达意",
        "d": "根据简单的文字描述，推荐符合描述的词语",
        "u": "https://shenyandayi.com/"
      },
      {
        "n": "九歌",
        "d": "Ai诗歌创作，来自清华的人工智能",
        "u": "https://jiuge.thunlp.org/"
      },
      {
        "n": "自动对对联",
        "d": "用AI深度学自动对对联",
        "u": "https://ai.binwang.me/couplet/"
      },
      {
        "n": "现代诗歌语料库",
        "d": "五四至今的所有流派",
        "u": "https://www.chinese-poetry.org/"
      },
      {
        "n": "搜韵网",
        "d": "诗词狂热者创建的检索网站",
        "u": "https://sou-yun.cn/"
      },
      {
        "n": "识典古籍",
        "d": "检索和阅读古籍",
        "u": "https://www.shidianguji.com/"
      },
      {
        "n": "全球漢籍影像開放集成系統",
        "d": "全球漢籍影像開放集成系統",
        "u": "https://guji.wenxianxue.cn/"
      },
      {
        "n": "书格",
        "d": "一个自由开放的在线古籍图书馆",
        "u": "https://new.shuge.org/"
      },
      {
        "n": "‎读典籍",
        "d": "句对齐文白对照读懂典籍",
        "u": "https://web.dudianji.com/"
      },
      {
        "n": "知识图谱",
        "d": "古籍检索工具",
        "u": "https://cnkgraph.com/"
      },
      {
        "n": "汉语方言发音字典",
        "d": "听一听不同地方的乡音吧",
        "u": "https://zh.voicedic.com/"
      },
      {
        "n": "收录了全国多地的方言和民谣，可搜索查询预览，还内置游戏模式",
        "d": "方言地图",
        "u": "https://dialect.quotemap.site/gallery"
      },
      {
        "n": "英语单词消消乐",
        "d": "单词匹配网页小游戏，内置丰富的词库",
        "u": "https://englishxxl.cn/"
      }
    ]
  },
  {
    "cate": "数学思维",
    "tools": [
      {
        "n": "数字 1~10 描红练习",
        "d": "2024新教材里1～10数字PDF",
        "u": "https://wwfi.lanzouj.com/ig3hU29b5x0b"
      },
      {
        "n": "口算题卡",
        "d": "在线口算题卡生成",
        "u": "http://www.kebendashi.com/"
      },
      {
        "n": "计算器",
        "d": "网页版计算器",
        "u": "https://edui123.com/calculator/"
      },
      {
        "n": "数独酷",
        "d": "界面精美、功能全面、开箱即玩的在线数独游戏。",
        "u": "https://sudoku.sinqi.tools/zh"
      },
      {
        "n": "数独",
        "d": "在线数独练习",
        "u": "https://sudoku.com/zh"
      },
      {
        "n": "扫雷",
        "d": "扫雷 Win98 复古版",
        "u": "https://ohminesweeper.online/"
      },
      {
        "n": "扫雷Online",
        "d": "多种模式、专业教程的扫雷",
        "u": "https://minesweeper.online/cn/"
      },
      {
        "n": "尺规作图",
        "d": "在线玩欧式几何的乐趣",
        "u": "https://www.euclidea.xyz/en/game/packs"
      },
      {
        "n": "Geogebar 数学画板",
        "d": "在线计算画几何",
        "u": "https://www.geogebra.org/calculator"
      },
      {
        "n": "Desmos 数学画板",
        "d": "在线计算、画几何",
        "u": "https://www.desmos.com/geometry-beta?lang=zh-CN"
      },
      {
        "n": "微软数学求解器",
        "d": "微软推出的在线数学求解器",
        "u": "https://mathsolver.microsoft.com/"
      },
      {
        "n": "看见统计",
        "d": "通过可视化的方式来学习统计学",
        "u": "https://seeing-theory.brown.edu/cn.html"
      },
      {
        "n": "分形花园",
        "d": "数学分形图",
        "u": "https://www.fractal.garden/"
      },
      {
        "n": "七巧板",
        "d": "在线游玩七巧板益智小游戏",
        "u": "https://blocks.ovh/"
      },
      {
        "n": "猜猜我是几",
        "d": "随机生成一个1到100之间的数。看你能否在更短的时间内猜出它。",
        "u": "https://edui123.com/caishu/"
      },
      {
        "n": "画圆圈",
        "d": "看谁能画个 100% 的圆",
        "u": "https://edui123.com/yuan/"
      },
      {
        "n": "手绘一个圆",
        "d": "手绘一个圆，创建属于你的完美无限值： π ！",
        "u": "https://edui123.com/pi/"
      },
      {
        "n": "汉诺塔",
        "d": "在线互动及自动演示",
        "u": "https://edui123.com/hnt/"
      },
      {
        "n": "在线迷宫",
        "d": "随机生成在线平面迷宫",
        "u": "https://maze.toys/"
      }
    ]
  },
  {
    "cate": "信息科技",
    "tools": [
      {
        "n": "哪吒打字2025",
        "d": "专业的在线打字练习平台",
        "u": "https://www.nezhadazi.com/"
      },
      {
        "n": "打字鸭",
        "d": "专业的在线打字练习平台",
        "u": "https://daziya.com/courses/"
      },
      {
        "n": "习字丛林",
        "d": "指法输入中文打字俱乐部",
        "u": "https://www.edclub.com/zh/library/%E4%B9%A0%E5%AD%97%E4%B8%9B%E6%9E%97"
      },
      {
        "n": "MakerWorld 免费打印模型",
        "d": "免费 3D 打印模型",
        "u": "https://makerworld.com/zh"
      },
      {
        "n": "科普中国网",
        "d": "让科技知识在网上和生活中流行",
        "u": "https://www.kepuchina.cn/"
      },
      {
        "n": "中国数字科技馆",
        "d": "国家级公益性科普服务平台",
        "u": "https://www.cdstm.cn/"
      },
      {
        "n": "重现化学",
        "d": "用视频捕捉化学反应中的缤纷色彩和微妙细节",
        "u": "https://www.envisioningchemistry.cn/"
      },
      {
        "n": "元素周期表Pro",
        "d": "高颜值化学必备小工具",
        "u": "https://pt.ziziyi.com/"
      },
      {
        "n": "世界地震地图",
        "d": "标识出了1980年后大于5.2级的地震",
        "u": "https://seismic-explorer.concord.org/"
      },
      {
        "n": "3D地球模型",
        "d": "在线地球模型",
        "u": "https://3d-app.yunser.com/earth"
      },
      {
        "n": "我们省在哪里",
        "d": "在地图中点击对应的省份",
        "u": "https://www.geoguessr.com/seterra/zh/vgp/3380"
      },
      {
        "n": "月球地图",
        "d": "嫦娥二号发布的全月影像图制作",
        "u": "https://ce2.greensea.org/"
      },
      {
        "n": "唤醒食物",
        "d": "食物营养成分与营养工具",
        "u": "https://www.foodwake.com/"
      },
      {
        "n": "天空有多高",
        "d": "用网页滚动形式展示了从地球到宇宙深空的距离",
        "u": "http://www.secaibi.com/howbigisspace/"
      },
      {
        "n": "Zoom Earth 天气",
        "d": "直观查看全球天气状况的网站",
        "u": "https://earth.nullschool.net/zh-cn/"
      },
      {
        "n": "我们省在哪里",
        "d": "一个全国省份识记的小测验网站。根据随机显示的省份名，点击地图中对应位置。",
        "u": "https://edui123.com/shengfen/"
      },
      {
        "n": "生物 3D 模型",
        "d": "2000多种生物的 3D 模型。",
        "u": "https://sketchfab.com/ffishAsia-and-floraZia"
      },
      {
        "n": "中国人口实时统计",
        "d": "实时动态显示当前中国人口",
        "u": "https://countrymeters.info/cn/China"
      },
      {
        "n": "Starlink 卫星覆盖图",
        "d": "实时显示 Starlink 卫星的位置，目前有4000多颗",
        "u": "https://satellitemap.space/"
      }
    ]
  },
  {
    "cate": "艺术历史",
    "tools": [
      {
        "n": "大唐营造",
        "d": "唐代建筑线上特展",
        "u": "https://news.cgtn.com/event/2025/tang-architecture/index.html#/building-design"
      },
      {
        "n": "故宫博物院藏品",
        "d": "故宫开放186万藏品的数据库",
        "u": "https://zm-digicol.dpm.org.cn/"
      },
      {
        "n": "全景故宫",
        "d": "在线浏览全景3D故宫",
        "u": "https://pano.dpm.org.cn/"
      },
      {
        "n": "小西天 3D 全景",
        "d": "山西省隰县小西天的网页 3D 全景导览。",
        "u": "https://funes.world/apps/the-hanging-sculptures-of-the-xiaoxitian"
      },
      {
        "n": "数字敦煌",
        "d": "敦煌研究院出品",
        "u": "https://www.e-dunhuang.com/"
      },
      {
        "n": "无水印世界名画",
        "d": "超10万张无水印超高清世界名画免费下",
        "u": "https://www.nbfox.com/topics/world-famous-paintings/"
      },
      {
        "n": "皮影数字博物馆",
        "d": "中国美术学院出品",
        "u": "http://shadow.caa.edu.cn/"
      },
      {
        "n": "走进 3D 吉萨大金字塔",
        "d": "用鼠标导航，一路在金字塔内部漫游",
        "u": "https://giza.mused.org/zh-hans/guided/335/da-jin-zi-ta-nei-bu"
      },
      {
        "n": "陕西博物馆实景浏览",
        "d": "线上参观陕西博物馆，360度展示",
        "u": "https://720yun.com/vr/3e22dasfmlw"
      },
      {
        "n": "卢浮宫建筑群",
        "d": "在线浏览卢浮宫",
        "u": "https://www.louvre.fr/zh-hans/tansuofaxian/lufugongjianzhuqun"
      },
      {
        "n": "千亿像素看中国",
        "d": "世界之美, 记录细节！",
        "u": "http://www.bigpixel.cn/"
      },
      {
        "n": "天空之城",
        "d": "全球航拍爱好者和专业摄影师的作品社区",
        "u": "https://www.skypixel.com/"
      },
      {
        "n": "指尖上",
        "d": "海量全面精美的VR全景旅游景点介绍",
        "u": "https://www.zhijianshang.com/"
      },
      {
        "n": "云彩图片集",
        "d": "全方位、多角度欣赏云彩",
        "u": "https://www.ianfisherart.com/gallery/painting"
      },
      {
        "n": "人物志",
        "d": "权威的历史人物传记网站",
        "u": "https://renwuzhi.wiki/"
      },
      {
        "n": "历史气温数据查询",
        "d": "提供全球城市历史气象数据、温度趋势分析和气温统计信息",
        "u": "https://historicaltemperature.org/"
      },
      {
        "n": "全历史",
        "d": "以AI知识图谱为核心引擎，展现历史内容",
        "u": "https://www.allhistory.com/"
      },
      {
        "n": "历朝代视频讲解",
        "d": "点击具体的朝代，就能观看精选的讲解视频",
        "u": "https://historyline.19921014.xyz/"
      },
      {
        "n": "中国家谱知识服务平台",
        "d": "上海图书馆旗下家谱查询平台",
        "u": "https://jiapu.library.sh.cn/"
      },
      {
        "n": "中国传统纹样图鉴",
        "d": "一个开源的中国传统纹样图录站",
        "u": "https://wenyang.net/"
      }
    ]
  },
  {
    "cate": "综合百科",
    "tools": [
      {
        "n": "二十四节气",
        "d": "当年节气查询",
        "u": "https://jieqi.51240.com/"
      },
      {
        "n": "世界各国国歌、国旗和国徽",
        "d": "收录205个国家和地区的数据",
        "u": "https://guo.ge/"
      },
      {
        "n": "中国铁路地图",
        "d": "查看全国铁路的路线图",
        "u": "http://cnrail.geogv.org/zhcn/"
      },
      {
        "n": "中国城市地铁可视化",
        "d": "展示中国部分城市地铁线路的可视化应用",
        "u": "https://subway.cuvii.dev/"
      },
      {
        "n": "折纸俱乐部",
        "d": "看动画，学折纸艺术",
        "u": "http://cn.origami-club.com/"
      },
      {
        "n": "爱折纸网",
        "d": "儿童折纸大全，分享手工折纸的乐趣",
        "u": "https://www.aizhezhi.com/"
      },
      {
        "n": "纸飞机",
        "d": "汇集了几十种纸飞机的折法，从简单到复杂，都有详细的步骤图",
        "u": "https://foldnfly.com/#/1-1-1-1-1-1-1-1-2"
      }
    ]
  },
  {
    "cate": "趣味互动",
    "tools": [
      {
        "n": "光学玩具",
        "d": "视觉错觉 &amp; 大脑扭曲",
        "u": "https://edui123.com/cuojue/"
      },
      {
        "n": "丝绸（Silk）",
        "d": "酷炫光影对称作图",
        "u": "https://edui123.com/silk/"
      },
      {
        "n": "投胎模拟器",
        "d": "根据中国公布的最新出生人口数据，计算出生在某地区的可能性。",
        "u": "https://toutai.cc/"
      },
      {
        "n": "虚拟泡泡膜",
        "d": "在线捏泡泡膜，听个响",
        "u": "https://edui123.com/nie/"
      },
      {
        "n": "WIN画板",
        "d": "经典怀旧 Windows 系统自带画板工具",
        "u": "https://jspaint.app/"
      },
      {
        "n": "像素画",
        "d": "优雅的像素画工具",
        "u": "https://edui123.com/pixxel/"
      },
      {
        "n": "自由钢琴",
        "d": "最美在线钢琴应用",
        "u": "https://www.autopiano.cn/"
      },
      {
        "n": "架子鼓",
        "d": "敲打出你自己的旋律",
        "u": "http://guozhivip.com/jzg/"
      },
      {
        "n": "智能简笔画",
        "d": "神经网络能学会辨识涂鸦",
        "u": "https://www.autodraw.com/"
      },
      {
        "n": "快速涂鸦",
        "d": "在线AI识别简笔画工具",
        "u": "https://quickdraw.withgoogle.com/"
      },
      {
        "n": "涂鸦扩散",
        "d": "AI 把你的涂鸦变成精美的图像",
        "u": "https://scribblediffusion.com/"
      },
      {
        "n": "3D魔方还原",
        "d": "在线3D魔方还原",
        "u": "https://edui123.com/cube/"
      },
      {
        "n": "扫清黑洞",
        "d": "排除未知块背后的黑洞",
        "u": "https://proxx.app/"
      },
      {
        "n": "井字棋",
        "d": "会飞的井字棋",
        "u": "https://edui123.com/jing/"
      },
      {
        "n": "黑白棋",
        "d": "经典自制黑白棋",
        "u": "https://edui123.com/hbq/"
      },
      {
        "n": "在线国际象棋",
        "d": "免费、开源、没有广告、支持多语言的在线国际象棋游戏",
        "u": "https://lichess.org/"
      },
      {
        "n": "连线 Play Lines",
        "d": "把相同颜色的点都连接起来",
        "u": "https://lines.frvr.com/"
      },
      {
        "n": "俄罗斯方块",
        "d": "在线版",
        "u": "https://edui123.com/tetris/"
      },
      {
        "n": "贪吃蛇",
        "d": "在线版",
        "u": "https://playsnake.org/"
      },
      {
        "n": "Euclidea3 解法",
        "d": "对应 Apple app store 里的 Euclidea3 游戏",
        "u": "https://edui123.com/euclidea/"
      },
      {
        "n": "在线养鱼",
        "d": "可以投递饲料，吸引金鱼",
        "u": "https://goldfishies.com/"
      },
      {
        "n": "萌猫弹琴",
        "d": "",
        "u": "http://tool.mkblog.cn/bongocat/"
      },
      {
        "n": "全球海底光缆",
        "d": "互动式的地球，上面有全世界海底光缆",
        "u": "https://he.net/3d-map/"
      },
      {
        "n": "波斯波利斯",
        "d": "波斯波利斯是古代波斯帝国的首都",
        "u": "https://persepolis.getty.edu/"
      },
      {
        "n": "中国空间站漫游",
        "d": "第一视觉全景虚拟漫游太空站",
        "u": "https://roam.cdstm.cn/roam/"
      },
      {
        "n": "城镇叠叠乐",
        "d": "自由度极高的古城镇建造游戏",
        "u": "https://oskarstalberg.com/Townscaper/"
      },
      {
        "n": "3D 俄罗斯方块",
        "d": "在线挑战 3D 俄罗斯方块",
        "u": "https://project.threejs-tetris-react.rylan.cn/"
      },
      {
        "n": "堆沙子游戏",
        "d": "堆个沙子也是艺术家",
        "u": "https://thisissand.com/"
      },
      {
        "n": "对称绘图",
        "d": "自动进行对称绘图，发光线条非常科幻酷炫",
        "u": "http://weavesilk.com/"
      },
      {
        "n": "Poki",
        "d": "丰富的免费在线游戏，从单人休闲到多人合作",
        "u": "https://poki.com/zh"
      },
      {
        "n": "零基础围棋学习",
        "d": "零基础学习围棋的在线教程",
        "u": "https://online-go.com/learn-to-play-go"
      }
    ]
  },
  {
    "cate": "课堂管理",
    "tools": [
      {
        "n": "Drawnix 白板工具",
        "d": "支持随便画画、画脑图、工作流程图",
        "u": "https://drawnix.com/"
      },
      {
        "n": "白板1.0",
        "d": "极简在线白板",
        "u": "https://edui123.com/bb/"
      },
      {
        "n": "文件传输",
        "d": "微信文件传输助手，手机电脑轻松互传文件。",
        "u": "https://filehelper.weixin.qq.com/"
      },
      {
        "n": "分秒计时器",
        "d": "极简分秒计时器",
        "u": "https://edui123.com/time/"
      },
      {
        "n": "每月重要节日",
        "d": "每月重要节日",
        "u": "https://edui123.com/jieri/"
      },
      {
        "n": "舒尔特方格",
        "d": "随时随地打开，开启专注力训练",
        "u": "https://edui123.com/schulte/"
      },
      {
        "n": "贾斯纳的猫",
        "d": "适合3&#43;岁的孩子发展逻辑语言技能",
        "u": "https://edui123.com/cat/"
      }
    ]
  },
  {
    "cate": "综合资源",
    "tools": [
      {
        "n": "国家智慧教育平台",
        "d": "微课、教材一应俱全",
        "u": "https://www.zxx.edu.cn"
      },
      {
        "n": "人教社中小学电子教材",
        "d": "人教社中小学电子教材",
        "u": "https://jc.pep.com.cn/"
      },
      {
        "n": "吾课网",
        "d": "课件下载",
        "u": "https://www.wookey.cn/kjfl"
      },
      {
        "n": "语文课标2022",
        "d": "2022年语文课程标准",
        "u": "https://edui123.com/ywkb/"
      },
      {
        "n": "数学课标2022",
        "d": "2022年数学课程标准",
        "u": "https://edui123.com/sxkb/"
      },
      {
        "n": "英语课标2022",
        "d": "2022年英语课程标准",
        "u": "https://edui123.com/yykb/"
      },
      {
        "n": "信息课标2022",
        "d": "2022年信息技术课程标准",
        "u": "https://edui123.com/xxkb/"
      },
      {
        "n": "小学语文教学助手",
        "d": "电子教材、课文朗读、生字视频等",
        "u": "https://edui123.com/ebook/xxyw/"
      },
      {
        "n": "小学数学教学助手",
        "d": "电子教材、单元目标等。",
        "u": "https://edui123.com/ebook/xxsx/"
      },
      {
        "n": "浙江省学科要求（18门）",
        "d": "浙江省义务教育阶段学科教学基本要求（2021版）",
        "u": "https://edui123.com/zjyq/"
      }
    ]
  },
  {
    "cate": "移动在线",
    "tools": [
      {
        "n": "DeepL ｜ 人工智能翻译网站",
        "d": "准确度极高的人工智能翻译网站",
        "u": "https://www.deepl.com/translator"
      },
      {
        "n": "周报生成器",
        "d": "简单描述工作内容帮你生成完整周报",
        "u": "https://weeklyreport.avemaria.fun/zh"
      },
      {
        "n": "Teach Anything",
        "d": "AI 教你任何事",
        "u": "https://www.teach-anything.com/"
      }
    ]
  },
  {
    "cate": "线上课程",
    "tools": [
      {
        "n": "三维地图看世界",
        "d": "B站:用三维地图，看美丽的蓝色星球！",
        "u": "https://space.bilibili.com/442603088/"
      },
      {
        "n": "跟着书本去旅行",
        "d": "以课本或经典名著为线索，在读万卷书的同时行万里路",
        "u": "https://tv.cctv.com/lm/gzsbqlx/"
      },
      {
        "n": "万物30秒",
        "d": "简单、粗暴、秒懂！",
        "u": "https://space.bilibili.com/357193460/video"
      },
      {
        "n": "星球研究所",
        "d": "B站:解构世间万物，探索极致世界。《这里是中国》作者。",
        "u": "https://space.bilibili.com/326427334"
      },
      {
        "n": "8KRAW",
        "d": "心里有梦，眼里有光，我们是摄影师",
        "u": "https://space.bilibili.com/21151219"
      },
      {
        "n": "《中科院科学公开课》",
        "d": "来自中科院物理所",
        "u": "https://www.bilibili.com/video/BV13i4y1y7Q7/"
      },
      {
        "n": "《被数学选中的人》",
        "d": "介绍数学作为最基础学科对于人类文明进程的意义",
        "u": "https://tv.cctv.com/2021/10/22/VIDA4gN1WkoTE5ffXVTFWVhN211022.shtml"
      },
      {
        "n": "《历史那些事》",
        "d": "一部“实验性”的历史文化纪录片",
        "u": "https://open.163.com/newview/movie/courseintro?newurl=MEK088GG1"
      },
      {
        "n": "TED精选演讲",
        "d": "TED精选演讲视频",
        "u": "https://space.bilibili.com/405054588/video"
      },
      {
        "n": "一席",
        "d": "中国TED演讲",
        "u": "https://yixi.tv/"
      },
      {
        "n": "TED演讲",
        "d": "technology, entertainment, design",
        "u": "https://www.ted.com/"
      },
      {
        "n": "译学馆",
        "d": "分享国外有价值的学习资源",
        "u": "https://www.yxgapp.com/"
      },
      {
        "n": "甬上云校",
        "d": "集各大区县优质微课",
        "u": "https://live.nbedumall.com/nbedu/schoolIndex/2677"
      },
      {
        "n": "希沃学院",
        "d": "教师专属信息化教学技能提升平台",
        "u": "https://study.seewoedu.cn/"
      },
      {
        "n": "北京明远教育书院",
        "d": "好课燎原",
        "u": "https://study.seewoedu.cn/zone/c09329acd1ef49048841690cf82ff9c8"
      },
      {
        "n": "天天公开课",
        "d": "浙江教研网出品",
        "u": "http://ttgkk.zjjys.org/"
      },
      {
        "n": "可汗学院",
        "d": "翻转学习的创立者，大量优质微课和在线练习",
        "u": "https://zh.khanacademy.org/"
      },
      {
        "n": "ScratchCN 中国爱好者社区",
        "d": "Scratch 第三方中文本地版本，访问保存速度大大提升。",
        "u": "https://www.scratch-cn.cn/"
      },
      {
        "n": "计算机科学速成课",
        "d": "共40集从“早期的计算”直到“奇点天网计算的未来”",
        "u": "https://www.bilibili.com/video/av21376839/"
      },
      {
        "n": "学音乐",
        "d": "循序渐进的了解音乐知识，还可以自己创作",
        "u": "https://learningmusic.ableton.com/zh-Hans/"
      },
      {
        "n": "国际乐谱库",
        "d": "收集全世界公开领域的乐谱",
        "u": "https://imslp.org/"
      },
      {
        "n": "网易公开课",
        "d": "国内外名校公开课，涉及广泛的学科，名校老师认真讲解深度剖析",
        "u": "https://open.163.com/"
      },
      {
        "n": "国家语言资源服务平台",
        "d": "能下载全套方正字体",
        "u": "http://fw.ywky.edu.cn/#/service"
      },
      {
        "n": "RegexLearn",
        "d": "游戏化思路学习正则",
        "u": "https://regexlearn.com/zh-cn"
      },
      {
        "n": "五子棋教学站",
        "d": "一个五子棋学习资料站",
        "u": "https://ku10.com/"
      },
      {
        "n": "为中文学习者设计的AI入门课",
        "d": "用可视化和交互演示，把 AI 的核心原理装进你的直觉",
        "u": "https://aipath.buynao.com/"
      }
    ]
  },
  {
    "cate": "文字编辑",
    "tools": [
      {
        "n": "提词器",
        "d": "在线提词器",
        "u": "https://cn.teleprompter-online.com"
      },
      {
        "n": "汉字转拼音",
        "d": "对多音字有更好的支持",
        "u": "https://quanxin.org/hanzi-to-pinyin"
      },
      {
        "n": "评语生成",
        "d": "多维度生成学生期末评语",
        "u": "https://class.acagrid.com/pc/comment"
      },
      {
        "n": "文本去重工具",
        "d": "找出多行文本中有重复的那些行",
        "u": "https://www.dute.org/text-remove-duplicates/"
      },
      {
        "n": "澳声通拼音编辑器",
        "d": "免费免安装，在线选音工具",
        "u": "https://toneoz.com/imez/"
      },
      {
        "n": "PearOCR文字识别",
        "d": "本地运算的文字识别，完全免费",
        "u": "https://pearocr.com/"
      },
      {
        "n": "白描",
        "d": "高准确度的文字识别、表格识别转Excel",
        "u": "https://web.baimiaoapp.com/"
      },
      {
        "n": "图片在线翻译器",
        "d": "将图片上的文本内容进行识别并翻译",
        "u": "https://translate.yandex.com/ocr"
      },
      {
        "n": "二维码识别",
        "d": "PC在线识别二维码",
        "u": "https://toolight.cn/img/qrcode"
      },
      {
        "n": "TTSMaker 文本转语音",
        "d": "免费的文本转语音工具",
        "u": "https://ttsmaker.com/zh-cn"
      },
      {
        "n": "Fish Audio 文本转语音",
        "d": "没有AI腔的AI文本转语音",
        "u": "https://fish.audio/zh-CN/"
      },
      {
        "n": "爱校对",
        "d": "由清华大学出品的文字校对、纠错、错别字检查工具",
        "u": "https://www.ijiaodui.com/"
      },
      {
        "n": "秘塔写作猫",
        "d": "AI校对文档、全文翻译、智能排版。",
        "u": "https://xiezuocat.com/"
      },
      {
        "n": "秀米",
        "d": "微信公众号编辑必备",
        "u": "https://xiumi.us/user/invitation/1wYsH-8vtHX"
      },
      {
        "n": "文案狗",
        "d": "给文案来点灵感！",
        "u": "http://www.wenangou.com/"
      },
      {
        "n": "微词云",
        "d": "非常实用简单的在线词云生成器",
        "u": "https://www.weiciyun.com/"
      },
      {
        "n": "词云统计",
        "d": "无广告、简单词云统计",
        "u": "http://cloud.niucodata.com/"
      },
      {
        "n": "图之典",
        "d": "制作和维护的数据可视化知识分享站点",
        "u": "http://www.tuzhidian.com/"
      },
      {
        "n": "美寄词云",
        "d": "文字云、照片墙在线生成器",
        "u": "https://www.moage.cn/"
      },
      {
        "n": "字体家",
        "d": "各种字体的高速免费下载",
        "u": "https://www.zitijia.com/"
      },
      {
        "n": "字体搬运工",
        "d": "免费商用字体下载",
        "u": "https://font.sucai999.com/"
      },
      {
        "n": "字体天下",
        "d": "各种字体的高速免费下载",
        "u": "http://www.fonts.net.cn/"
      },
      {
        "n": "免费字体",
        "d": "一个专门收集整理“免费商用字体",
        "u": "https://www.100font.com/"
      },
      {
        "n": "论文狗",
        "d": "论文狗免费论文查重系统",
        "u": "https://www.lunwengo.net/"
      }
    ]
  },
  {
    "cate": "图片处理",
    "tools": [
      {
        "n": "简单图片拼接",
        "d": "极简本地图片拼接工具",
        "u": "https://edui123.com/pj/"
      },
      {
        "n": "免费在线拼图工具",
        "d": "一个免费全面的在线拼图工具",
        "u": "https://img.ops-coffee.cn/zh/app/"
      },
      {
        "n": "3D图标",
        "d": "可爱卡通 3D 图标免费下载",
        "u": "https://www.thiings.co/things"
      },
      {
        "n": "艺术二维码生成器",
        "d": "参数化二维码生成器",
        "u": "https://qrbtf.com/"
      },
      {
        "n": "佐糖",
        "d": "免费在线AI抠图、去水印、修复老照片",
        "u": "https://picwish.cn/"
      },
      {
        "n": "去去去",
        "d": "一键涂抹，无痕去除水印、杂物",
        "u": "https://quququ.cn/"
      },
      {
        "n": "hama",
        "d": "基于人工智能的图像编辑服务，专门用于删除图像中的物体",
        "u": "https://www.hama.app/"
      },
      {
        "n": "删除图片元素",
        "d": "几秒钟删除图片中你不需要的东西",
        "u": "https://www.magiceraser.io"
      },
      {
        "n": "PhotoFunia",
        "d": "雪地写字效果、百老汇广告牌效果",
        "u": "https://photofunia.com/cn/"
      },
      {
        "n": "改图鸭",
        "d": "各种图片处理",
        "u": "https://www.gaituya.com/"
      },
      {
        "n": "改图宝",
        "d": "各种图片处理，制作印章等",
        "u": "https://www.gaitubao.com/"
      },
      {
        "n": "打码",
        "d": "在线图片打马赛克工具",
        "u": "https://redacted.app/"
      },
      {
        "n": "图片放大",
        "d": "AI人工智能图片放大",
        "u": "https://bigjpg.com/"
      },
      {
        "n": "图片放大2",
        "d": "Smart PNG / JPG Image Upscaler",
        "u": "https://imgupscaler.com/"
      },
      {
        "n": "http://Vectorizer.AI",
        "d": "JPEG 和 PNG 位图转换为 SVG 矢量图",
        "u": "https://vectorizer.ai/"
      },
      {
        "n": "remove.bg",
        "d": "图片背景消除，快速AI自动抠图！",
        "u": "https://www.remove.bg/zh"
      },
      {
        "n": "稿定抠图",
        "d": "在线删除图片背景",
        "u": "https://koutu.gaoding.com/"
      },
      {
        "n": "图片压缩工具",
        "d": "效果极佳的本地图片压缩工具",
        "u": "https://tool.tanpok.com"
      },
      {
        "n": "微图",
        "d": "极速图片压缩工具。",
        "u": "https://devtool.tech/tiny-image"
      },
      {
        "n": "最优图像优化",
        "d": "支持在线批量压缩图片",
        "u": "https://zh.recompressor.com/"
      },
      {
        "n": "TinyPNG",
        "d": "压缩PNG图片的同时保留透明度。",
        "u": "https://tinify.cn/"
      },
      {
        "n": "条形码在线生成",
        "d": "支持批量生成条形码",
        "u": "https://www.67tool.com/work/barcode"
      },
      {
        "n": "大众制图",
        "d": "免费标注、分段设色、流向地图",
        "u": "https://g.dituhui.com/new/"
      },
      {
        "n": "中国地图矢量图",
        "d": "阿里云数据可视化平台",
        "u": "https://datav.aliyun.com/portal/school/atlas/area_selector"
      },
      {
        "n": "手绘定格动画",
        "d": "把手绘图画转成 gif 定格动画",
        "u": "https://www.eatmy.art/"
      },
      {
        "n": "封面提取",
        "d": "微信公众号、B站视频封面提取",
        "u": "https://cover.h5551.com/"
      },
      {
        "n": "朋友圈转发截图生成工具",
        "d": "",
        "u": "https://akarin.dev/WechatMomentScreenshot/"
      },
      {
        "n": "网格背景制作",
        "d": "快速制作点、线、正方形、横线、六边形背景",
        "u": "https://edui123.com/wangge/"
      },
      {
        "n": "地图PixelMap",
        "d": "一个在线像素地图生成网站",
        "u": "https://pixelmap.amcharts.com/"
      },
      {
        "n": "创客贴",
        "d": "快速制作海报公众图",
        "u": "https://www.chuangkit.com/"
      },
      {
        "n": "稿定设计",
        "d": "做图做视频必备，在线设计神器",
        "u": "https://www.gaoding.com/"
      },
      {
        "n": "图改改在线PS",
        "d": "中文版本，免费在线PS",
        "u": "https://www.tugaigai.com/online_ps/"
      },
      {
        "n": "在线PS",
        "d": "中文版本，免费在线PS",
        "u": "https://zaixianps.net/"
      },
      {
        "n": "免费在线PS",
        "d": "免费在线PS",
        "u": "https://toolwa.com/ps/"
      },
      {
        "n": "在线PS",
        "d": "稿定出品，在线PS",
        "u": "https://www.uupoop.com/"
      },
      {
        "n": "在线作图",
        "d": "免费在线流程图思维导图",
        "u": "https://www.processon.com/"
      },
      {
        "n": "镝数图表",
        "d": "在线动态图表工具",
        "u": "https://dycharts.com/"
      },
      {
        "n": "树状图",
        "d": "在线制作树状流程图",
        "u": "https://c.p2hp.com/grapheditor/#/flow"
      },
      {
        "n": "Ai 思维导图",
        "d": "在线制作思维导图、流程图",
        "u": "https://amymind.com/"
      },
      {
        "n": "易制地图",
        "d": "手绘地图制作",
        "u": "https://www.makeamap.cn/"
      },
      {
        "n": "觅元素",
        "d": "免扣素材下载，每天前5次免费",
        "u": "http://www.51yuansu.com/"
      },
      {
        "n": "Pexels",
        "d": "免费素材图片、视频",
        "u": "https://www.pexels.com/zh-cn/"
      },
      {
        "n": "故宫壁纸",
        "d": "将历史的精彩收集到自己的手中",
        "u": "https://www.dpm.org.cn/lights/royal.html"
      },
      {
        "n": "Camarts",
        "d": "优秀的个人摄影作品",
        "u": "https://camarts.app/"
      },
      {
        "n": "手绘导图",
        "d": "",
        "u": "https://excalidraw.com/"
      },
      {
        "n": "tldraw",
        "d": "简单易用的在线白板",
        "u": "https://www.tldraw.com/"
      },
      {
        "n": "速写板",
        "d": "一款免费的在线画画工具",
        "u": "https://suxieban.com/index.html"
      },
      {
        "n": "智能证件照",
        "d": "上数百种证件照尺寸及底色，可生成各种尺寸",
        "u": "https://id.zhengzhaopai.com/"
      },
      {
        "n": "ILoveIMG",
        "d": "在线图片编辑器",
        "u": "https://www.iloveimg.com/zh-cn"
      },
      {
        "n": "腾讯抠图修复",
        "d": "支持人像修复、抠图",
        "u": "https://arc.tencent.com/zh/ai-demos/humansegmentation"
      }
    ]
  },
  {
    "cate": "文档转换",
    "tools": [
      {
        "n": "第1PPT",
        "d": "PPT背景图片，PPT模板免费下载",
        "u": "http://www.1ppt.com/"
      },
      {
        "n": "优品PPT",
        "d": "一个有情怀的免费PPT模板下载网站",
        "u": "http://www.ypppt.com/"
      },
      {
        "n": "站长之家PPT",
        "d": "免费PPT模板下载",
        "u": "http://sc.chinaz.com/ppt/free.html"
      },
      {
        "n": "觅知网",
        "d": "图片素材、PPT下载",
        "u": "https://www.51miz.com/"
      },
      {
        "n": "PDF爱好者",
        "d": "免费且易于使用的在线PDF工具",
        "u": "https://tools.pdf24.org/zh/"
      },
      {
        "n": "PDF爱好者",
        "d": "完全免费、易于使用、丰富的PDF处理工具",
        "u": "https://www.ilovepdf.com/zh-cn"
      },
      {
        "n": "Convertio — 文件转换器",
        "d": "全能在线转换文件的简单工具",
        "u": "https://convertio.co/zh/"
      },
      {
        "n": "轻闪PDF",
        "d": "轻松实现PDF转换为Word",
        "u": "https://lightpdf.cn/pdf-to-word"
      },
      {
        "n": "扫描 Look Scanned",
        "d": "把 PDF 变成好像扫描过的样子",
        "u": "https://lookscanned.io/"
      }
    ]
  },
  {
    "cate": "影音解析",
    "tools": [
      {
        "n": "小红书无水印下载",
        "d": "无需登录、能无水印下载小某书图片和视频的在线网页",
        "u": "https://xiaohongshu.day/"
      },
      {
        "n": "视频图集下载",
        "d": "支持小某书",
        "u": "https://downloadhd.net/"
      },
      {
        "n": "music-dl",
        "d": "下载各平台音乐",
        "u": "https://music.zkkp.nyc.mn/"
      },
      {
        "n": "网易云音乐无损解析",
        "d": "解析网易云音乐链接",
        "u": "https://api.toubiec.cn/wyapi.html"
      },
      {
        "n": "无损音乐",
        "d": "全网无损音乐免费下载",
        "u": "https://flac.life/"
      },
      {
        "n": "放屁音乐网",
        "d": "在线播放音乐和免费下载",
        "u": "https://www.fangpi.net/"
      },
      {
        "n": "煎饼搜",
        "d": "在线播放音乐和免费下载",
        "u": "https://www.jbsou.cn/"
      },
      {
        "n": "声带去除和隔离",
        "d": "在线去人声、分割、合并音乐等",
        "u": "https://vocalremover.org/ch/"
      },
      {
        "n": "LALAL.AI",
        "d": "从任何音频和视频中提取人声、伴奏和各种乐器",
        "u": "https://www.lalal.ai/zh-hans/"
      },
      {
        "n": "AI音频降噪工具",
        "d": "Adobe推出用于消除口语音频、录音中的噪音",
        "u": "https://podcast.adobe.com/enhance"
      },
      {
        "n": "小森平的免费下载音效",
        "d": "免费的约1800 种声音音效",
        "u": "https://taira-komori.net/freesoundcn.html"
      },
      {
        "n": "耳聆网",
        "d": "免费的音效素材分享",
        "u": "https://www.ear0.com/"
      },
      {
        "n": "爱给网",
        "d": "音效下载",
        "u": "http://www.aigei.com/"
      },
      {
        "n": "蜜蜂去水印",
        "d": "免费去掉各大短视频app水印工具",
        "u": "https://video.ciding.cc/"
      },
      {
        "n": "无水印视频解析",
        "d": "仅支持抖音/快手/微视/火山/西瓜视频/皮皮虾/知乎视频/微博/Bilibili无水印解析",
        "u": "https://imyshare.com/parsevideo/"
      },
      {
        "n": "微博党",
        "d": "视频在线下载微信、腾讯、优酷、头条等",
        "u": "http://weibodang.cn/videoextractor/"
      },
      {
        "n": "抖音短视频下载",
        "d": "抖音短视频无水印解析下载",
        "u": "http://tool.liumingye.cn/douyin/"
      },
      {
        "n": "短视频解析下载",
        "d": "短视频解析下载",
        "u": "https://bilibili.iiilab.com/"
      },
      {
        "n": "短视频下载",
        "d": "抖音、快手、小红书、蘑菇街、绿洲、哔哩哔哩视频下载",
        "u": "https://vtool.pro/"
      },
      {
        "n": "视频去背景",
        "d": "",
        "u": "https://www.unscreen.com/"
      },
      {
        "n": "影视飓风",
        "d": "高清视频素材库",
        "u": "https://www.ysjf.com/materialLibrary"
      },
      {
        "n": "极影解析",
        "d": "在线解析视频",
        "u": "https://movie.sitenav.cn/"
      }
    ]
  },
  {
    "cate": "网盘分享",
    "tools": [
      {
        "n": "小码短链接",
        "d": "短链接生成器，简单易用可统计",
        "u": "https://xiaomark.com/"
      },
      {
        "n": "MUSE",
        "d": "文件传输，不限速高品质",
        "u": "https://musetransfer.com/"
      },
      {
        "n": "钛盘",
        "d": "临时文件分享",
        "u": "https://app.tmp.link/"
      },
      {
        "n": "蓝奏云",
        "d": "不限速文件分享",
        "u": "https://www.lanzou.com/"
      },
      {
        "n": "文叔叔",
        "d": "极速传文件给他人",
        "u": "https://www.wenshushu.cn/"
      },
      {
        "n": "wormhole",
        "d": "秒传 10G 大文件",
        "u": "https://wormhole.app/"
      },
      {
        "n": "草船",
        "d": "文件传输工具",
        "u": "https://2w.ma/"
      },
      {
        "n": "Note.ms",
        "d": "在线记事本，用于在你的各个设备之间传网址和大段文本",
        "u": "https://note.ms/"
      },
      {
        "n": "网络剪贴板",
        "d": "提供数据暂存和传送服务",
        "u": "https://netcut.cn/"
      }
    ]
  },
  {
    "cate": "实用软件",
    "tools": [
      {
        "n": "猫爪",
        "d": "一个浏览器插件搞定 99% 在线音视频下载",
        "u": "https://o2bmm.gitbook.io/cat-catch"
      },
      {
        "n": "小旺AI截图",
        "d": "首款接入DeepSeek的AI截图神器！轻巧、好用、免费、无广告！",
        "u": "https://www.xiaowang.com/"
      },
      {
        "n": "水豚鼠标助手",
        "d": "强大的屏幕演示工具",
        "u": "https://shuitunapp.com/"
      },
      {
        "n": "抽奖系统",
        "d": "一个简易的随机抽奖系统",
        "u": "https://edui123.com/choujiang/"
      },
      {
        "n": "百度脑图",
        "d": "在线思维导图制作与分享",
        "u": "https://naotu.baidu.com/"
      },
      {
        "n": "Office Tool Plus",
        "d": "一键部署新版本 Office 全家桶，免费！",
        "u": "https://otp.landian.vip/zh-cn/"
      },
      {
        "n": "KMS Cloud",
        "d": "一键激活windows和office脚本",
        "u": "https://kms.cangshui.net/"
      },
      {
        "n": "Chrome扩展下载",
        "d": "下载Chrome扩展插件Crx离线安装包",
        "u": "https://crxdl.com/"
      },
      {
        "n": "APK Downloader",
        "d": "APK Downloader 离线下载",
        "u": "https://apkcombo.com/downloader/"
      },
      {
        "n": "希沃白板",
        "d": "为互动教学而生的课件制作软件",
        "u": "https://easinote.seewo.com/"
      },
      {
        "n": "希沃白板（网页版）",
        "d": "开箱即用，无需下载软件！",
        "u": "https://enweb.seewo.com/"
      },
      {
        "n": "班级优化大师",
        "d": "用AI让班级管理更简单",
        "u": "https://care.seewo.com/"
      },
      {
        "n": "Everything",
        "d": "Windows 本地搜索软件，极速定位文件和文件夹",
        "u": "https://www.voidtools.com/zh-cn/"
      },
      {
        "n": "Snipaste - 截图 &#43; 贴图",
        "d": "不仅可以截图，而且可以将截图作为便利贴，放到屏幕上作为提醒事项。",
        "u": "https://zh.snipaste.com/"
      },
      {
        "n": "万彩办公大师",
        "d": "办公必备的小工具百宝箱",
        "u": "http://www.wofficebox.com/"
      },
      {
        "n": "XnConvert",
        "d": "跨平台的图片批处理软件",
        "u": "https://www.xnview.com/en/xnconvert/#downloads"
      },
      {
        "n": "QQ影音",
        "d": "本地无广告视频播放器",
        "u": "https://pc.qq.com/detail/8/detail_8.html"
      },
      {
        "n": "火绒安全",
        "d": "杀防一体的安全软件",
        "u": "https://www.huorong.cn/person5.html"
      },
      {
        "n": "ScreenToGif",
        "d": "快速录制屏幕上的指定区域存为gif",
        "u": "https://www.screentogif.com/"
      },
      {
        "n": "WiFi Card",
        "d": "打印一张带有 WiFi 详细信息的登录卡片",
        "u": "https://wificard.io/"
      },
      {
        "n": "PortableApps",
        "d": "免费便携版软件下载",
        "u": "https://portableapps.com/zh-cn"
      },
      {
        "n": "稀缺软件下载",
        "d": "懒得勤快",
        "u": "https://masuit.com/"
      },
      {
        "n": "科技爱好者周刊",
        "d": "记录每周值得分享的科技内容",
        "u": "https://www.ruanyifeng.com/blog/weekly/"
      },
      {
        "n": "小众软件",
        "d": "分享免费、小巧、实用、有趣、绿色的软件",
        "u": "https://www.appinn.com/"
      },
      {
        "n": "PDFgear",
        "d": "一个内置ChatGPT的PDF阅读器，目前完全免费。",
        "u": "https://www.pdfgear.com/zh/"
      },
      {
        "n": "123APPS",
        "d": "视频、音频、文档等编辑转换创建",
        "u": "https://123apps.com/cn/"
      }
    ]
  },
  {
    "cate": "影视媒体",
    "tools": [
      {
        "n": "CCTV央视直播",
        "d": "在线播放央视频道",
        "u": "http://tv.cctv.com/live/"
      },
      {
        "n": "芒果TV",
        "d": "大家都在看的在线视频网站",
        "u": "https://www.mgtv.com/"
      },
      {
        "n": "腾讯视频",
        "d": "中国领先的在线视频媒体平台",
        "u": "https://v.qq.com/"
      },
      {
        "n": "优酷",
        "d": "这世界很酷",
        "u": "https://youku.com/"
      },
      {
        "n": "爱奇艺",
        "d": "在线视频",
        "u": "https://www.iqiyi.com/"
      }
    ]
  },
  {
    "cate": "音乐阅读",
    "tools": [
      {
        "n": "微信读书",
        "d": "提供极致阅读体验。",
        "u": "https://weread.qq.com/"
      },
      {
        "n": "无名图书",
        "d": "",
        "u": "https://www.book123.info/"
      },
      {
        "n": "Z-Library国内镜像",
        "d": "免费下载全球最大的数字图书馆",
        "u": "https://www.ooopn.com/tool/zlibrary/"
      },
      {
        "n": "自然声音",
        "d": "在线聆听世界各地大自然声音",
        "u": "https://earth.fm/"
      },
      {
        "n": "YesPlayMusic",
        "d": "高颜值的第三方网易云播放器",
        "u": "https://music.qier222.com"
      },
      {
        "n": "QQ音乐",
        "d": "千万正版音乐海量无损曲库",
        "u": "https://y.qq.com/"
      },
      {
        "n": "酷狗",
        "d": "酷狗音乐-就是歌多",
        "u": "http://www.kugou.com/"
      },
      {
        "n": "酷我",
        "d": "无损音质正版在线试听网站",
        "u": "http://www.kuwo.cn/"
      }
    ]
  },
  {
    "cate": "更多收录",
    "tools": [
      {
        "n": "Trae AI",
        "d": "字节跳动旗下 AI 编程软件",
        "u": "https://www.trae.com.cn/"
      },
      {
        "n": "深度求索 DeepSeek",
        "d": "深度求索",
        "u": "https://chat.deepseek.com/"
      },
      {
        "n": "豆包",
        "d": "多模态、AI 云盘、AI 电脑",
        "u": "https://www.doubao.com/"
      },
      {
        "n": "腾讯朱雀AI文本检测",
        "d": "免费的在线AI检测助手",
        "u": "https://matrix.tencent.com/ai-detect/"
      },
      {
        "n": "九章随时问",
        "d": "像老师一样一步步引导学生思考， 听不懂时随时问。",
        "u": "https://www.mathgpt.com/"
      },
      {
        "n": "林间聊愈室",
        "d": "懂你情绪的虚拟伙伴",
        "u": "https://xindaoapp.com.cn/"
      },
      {
        "n": "沉浸式翻译",
        "d": "网页翻译插件， 支持在线双语对照",
        "u": "https://immersivetranslate.com/zh-Hans/"
      },
      {
        "n": "微信输入法",
        "d": "自带满血 DeepSeek",
        "u": "https://z.weixin.qq.com/"
      },
      {
        "n": "元宝",
        "d": "腾讯旗下可搜索微信公众号文章",
        "u": "https://yuanbao.tencent.com/"
      },
      {
        "n": "MiniMax 语音",
        "d": "文字转语音，去除音频中的背景噪音，获得清晰纯净的人声",
        "u": "https://www.minimaxi.com/audio"
      },
      {
        "n": "TTS Omni",
        "d": "自然人声般的语音效果",
        "u": "https://www.ttsomni.com/zh"
      },
      {
        "n": "海螺语音",
        "d": "文字转语音",
        "u": "https://hailuoai.com/audio"
      },
      {
        "n": "即梦",
        "d": "字节跳动旗下生图生视频",
        "u": "https://jimeng.jianying.com/"
      },
      {
        "n": "可灵",
        "d": "一句话让照片动起来",
        "u": "https://app.klingai.com/cn/"
      },
      {
        "n": "腾讯智影云剪辑",
        "d": "数字人播报、文本配音等",
        "u": "https://zenvideo.qq.com/"
      },
      {
        "n": "Napkin AI",
        "d": "文本可视化",
        "u": "https://app.napkin.ai/"
      },
      {
        "n": "3MinCard",
        "d": "文章转个性化卡片",
        "u": "https://card.3min.top/new"
      },
      {
        "n": "通往AGI之路",
        "d": "免费在线 AI 社区",
        "u": "https://www.waytoagi.com/zh"
      },
      {
        "n": "AI工具集",
        "d": "1000&#43; AI工具集合，国内外AI工具集导航大全",
        "u": "https://ai-bot.cn/"
      },
      {
        "n": "扣子",
        "d": "智能体开发",
        "u": "https://www.coze.cn/"
      }
    ]
  },
  {
    "cate": "更多导航",
    "tools": [
      {
        "n": "Tool Ai",
        "d": "收录了全球5000个 AI 网站",
        "u": "https://www.toolai.io/"
      },
      {
        "n": "有趣网址之家",
        "d": "收藏全球最有趣的网站",
        "u": "https://youquhome.com/"
      },
      {
        "n": "帮小忙",
        "d": "QQ浏览器出品线上工具宝",
        "u": "https://tool.browser.qq.com/"
      },
      {
        "n": "工具邦",
        "d": "记分板、时钟、抽签、在线直尺、量角器等",
        "u": "https://cn.piliapp.com/"
      },
      {
        "n": "数字帝国",
        "d": "强大的、开放的、免费的数学工具",
        "u": "https://zh.numberempire.com/"
      },
      {
        "n": "即时工具",
        "d": "数据图表、文本视频等在线工具",
        "u": "https://www.67tool.com/rank/new"
      },
      {
        "n": "UU在线工具",
        "d": "314款在线工具",
        "u": "https://uutool.cn/"
      },
      {
        "n": "独特工具箱",
        "d": "方便、快捷、免费的在线工具",
        "u": "https://www.dute.org"
      },
      {
        "n": "Dochub 优质文档",
        "d": "一站式优质文章和文档聚合站点",
        "u": "https://www.dochub.wiki/"
      }
    ]
  }
]
